import { Component, Input } from '@angular/core';
import { ProfilCaisse } from 'src/app/api/model/profil-caisse.model';

@Component({
  selector: 'app-info-profil-caisse-folio',
  templateUrl: './info-profil-caisse-folio.component.html',
  styleUrls: ['./info-profil-caisse-folio.component.scss'],
  standalone: false,
})
export class InfoProfilCaisseFolioComponent {
  @Input() profilCaisseFolio: ProfilCaisse[];
  @Input() autresCompte: boolean = false;

  constructor() {}
}
